<template>
  <head>
    <meta charset="UTF-8">
    <title> | Habilite-se</title>
  </head>
  <div class="container-fluid">
    <div class="card shadow-sm">
      <div class="card-header">
        <h3 class="card-title"><span class="fa fa-edit"></span>&nbsp;&nbsp; Novo template</h3>
        <div class="card-toolbar">
          <Link class="btn btn-secondary" :href="props.route_to_back" as=button><i class="fa fa-reply"></i>&nbsp;Voltar
          </Link>
        </div>
      </div>
      <div class="card-body">
        <form action="/dashboard/master/template-documents/send-document" method="POST" enctype="multipart/form-data">
          <div class="row">
            <div class="form-group my-3 col-md-6">
              <label>Nome</label>
              <input v-model="form_page.name" class="form-control form-control-solid" name="name" type="text">
            </div>
            <div class="form-group my-3 col-md-6">
              <label>Categoria</label>
              <!-- Categoria não precisa de select2 (evita conflito com init global do plugin em ".select2") -->
              <select v-model="form_page.option" class="form-control form-control-solid" name="category">
                <option v-for="options in category">{{ options }}</option>
              </select>
            </div>
            <div class="form-group my-2 col-md-12">
              <label>Arquivo</label>
              <input ref="file" name="file" type="file" class="form-control" @change="onFileChange" />
              <small>*O arquivo precisa ser na extensão .docx </small><br>
            </div>
          </div>
          <div class="text-end">
            <button class="btn btn-success" type="submit">Enviar</button>
          </div>
        </form>
      </div>

      <!-- Pré-inspeção: mostra macros detectadas antes de enviar -->
      <div v-if="inspectState.status !== 'idle'" class="card-body">
        <div v-if="inspectState.status === 'loading'" class="alert alert-info">
          Lendo macros do arquivo...
        </div>

        <div v-else-if="inspectState.status === 'error'" class="alert alert-danger">
          {{ inspectState.message }}
        </div>

        <div v-else-if="inspectState.status === 'loaded'">
          <div v-if="inspectState.result && !inspectState.result.valid" class="alert alert-danger">
            <div><strong>O arquivo tem problemas e será bloqueado no upload:</strong></div>
            <ul class="mb-0">
              <li v-for="(e, idx) in inspectState.result.errors" :key="idx">{{ e }}</li>
            </ul>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="card border">
                <div class="card-header"><strong>Macros encontradas (${...})</strong></div>
                <div class="card-body" style="max-height: 250px; overflow:auto">
                  <div v-if="!inspectState.result?.template_macros?.length" class="text-muted">Nenhuma</div>
                  <ul v-else class="mb-0">
                    <li v-for="m in inspectState.result.template_macros" :key="m">
                      <span v-pre>${</span>{{ m }}<span v-pre>}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card border">
                <div class="card-header"><strong>Macros antigas detectadas (<span v-pre>{{...}}</span>)</strong></div>
                <div class="card-body" style="max-height: 250px; overflow:auto">
                  <div v-if="!inspectState.result?.legacy_macros?.length" class="text-muted">Nenhuma</div>
                  <ul v-else class="mb-0">
                    <li v-for="m in inspectState.result.legacy_macros" :key="m">
                      <span v-pre>{{</span>{{ m }}<span v-pre>}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card border">
                <div class="card-header"><strong>Macros desconhecidas</strong></div>
                <div class="card-body" style="max-height: 250px; overflow:auto">
                  <div v-if="!inspectState.result?.unknown_macros?.length" class="text-muted">Nenhuma</div>
                  <ul v-else class="mb-0">
                    <li v-for="m in inspectState.result.unknown_macros" :key="m">
                      <span v-pre>${</span>{{ m }}<span v-pre>}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="form_page.option" class="card-body">
        <div class="row">
          <div class="col-md-7 align-self-center">
            <h3 class="card-title">
              <span class="fa fa-edit"></span>
              &nbsp;&nbsp; Lista de macros
            </h3>
          </div>
          <div class="col-md-5">
            <label>
              Filtro
            </label>
            <div class="input-group mb-3">
              <input v-model="filter_description" type="text" class="form-control">
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <div class="alert alert-success" role="alert">
            <small>
              O código deve ser preenchido no arquivo usando o modelo abaixo (sem espaços) para ser substituído automaticamente.
            </small>
          </div>
          <table class="table table-striped gy-5 gs-5">
            <thead>
              <tr>
                <td>
                  Descrição
                </td>
                <td>
                  Valor de referencia
                </td>
                <td>
                  Código
                </td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="list in filtered" class="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                <td> {{ list.description }}</td>
                <td> {{ list.reference }}</td>
                <td>
                  <span v-pre>
                    ${</span>{{ list.code }}<span v-pre>}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

import { Link } from '@inertiajs/vue3'
import { computed, ref, watch } from 'vue';
import axios from 'axios';


var form_page = ref({
  option: '',
  name: ''
});

const filter_description = ref('');

interface list {
  code: string,
  reference: string,
  description: string,
  category: string,
}

const props = defineProps({
  list: { type: Array<list>, required: true },
  route_inspect_macros: { type: String, required: true },
  route_to_back: { type: String, required: true }
})

const file = ref<HTMLInputElement | null>(null);

type InspectStatus = 'idle' | 'loading' | 'loaded' | 'error';
type InspectResult = {
  valid: boolean;
  errors: string[];
  template_macros: string[];
  legacy_macros: string[];
  unknown_macros: string[];
  allowed_macros: string[];
};

const inspectState = ref<{ status: InspectStatus; message?: string; result?: InspectResult }>({
  status: 'idle',
});

async function onFileChange() {
  await inspectSelectedFile();
}

async function inspectSelectedFile() {
  const f = file.value?.files?.[0];
  if (!f) {
    inspectState.value = { status: 'idle' };
    return;
  }

  const category = form_page.value.option;
  if (!category) {
    inspectState.value = { status: 'error', message: 'Selecione a categoria para ler as macros.' };
    return;
  }

  inspectState.value = { status: 'loading' };
  try {
    const form = new FormData();
    form.append('file', f);
    form.append('category', category);

    const { data } = await axios.post(props.route_inspect_macros, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    inspectState.value = { status: 'loaded', result: data };
  } catch (e: any) {
    const msg = e?.response?.data?.message || 'Erro ao ler macros do arquivo.';
    inspectState.value = { status: 'error', message: msg };
  }
}

// Re-inspeciona ao trocar a categoria (porque o dicionário muda)
watch(
  () => form_page.value.option,
  async (newCategory, oldCategory) => {
    if (newCategory === oldCategory) return;
    if (!newCategory) {
      inspectState.value = { status: 'idle' };
      return;
    }
    await inspectSelectedFile();
  }
);


const filtered = computed(() => {
  return props.list.filter(item => {
    const find_category = item.category === form_page.value.option;
    const f = (filter_description.value || '').toLowerCase()
    return (item.description.toLowerCase().includes(f) || item.code.toLowerCase().includes(f)) && find_category
  });
})

const category = computed(() => {
  const categoriesUnicas = props.list.filter((obj, pos, arr) => {
    return arr.map(mapObj => mapObj['category']).indexOf(obj['category']) === pos;
  }).map(obj => obj.category);
  return categoriesUnicas
})
</script>
